import React from "react";
import ActionRequestNotification from "../actionRequired/ActionRequestNotification";

// Define notification types
export type NotificationType = "success" | "danger" | "warning" | "info";

// Define Notification type
export interface Notification {
  text: string;
  type: NotificationType;
  key: string;
}

// Define Props type for the component
interface NotificationListProps {
  notifications: Notification[] | undefined;
}

// Notification Component
const NotificationList: React.FC<NotificationListProps> = ({ notifications }) => {
  if (notifications === undefined) { return <></>; }

  return (
    <>
      {notifications.map((notification, index) => (
        <ActionRequestNotification key={notification.key} mode="Notification" type={notification.type} text={notification.text} notificationKey={notification.key} />
      ))}
    </>
  );
};

export default NotificationList;
